module.exports = __webpack_public_path__ + "static/media/2.3cb698bf.jpg";